import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import DynamicForm from "Component/DynamicForm";
import { dateinputconverter } from "Component/DynamicForm/Fields/Date";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { ErrorMessages } from "Constants";
import get from "lodash/get";
import React from "react";
import { FormattedMessage } from "react-intl";
import { instance } from "../../../../Actions/AxiosInstance";
import addressEmployee from "../../../../Assets/Images/education.svg";
import If from '../../../../Component/Common/If';
import createstore from "../../../../store";
import { convertDateForBackend } from "../../../../Utils";
import CreateComp from "../create";
import { NoRecordFound } from "./NoRecordFound";

class EmpcustomData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountid: null,
      subscriptionid: null,
      countrytimezoneid: null,
      employeeid: null,
      ShortDateFormat: null,
      colleagueid: null,
      datareceived: true,
      docList: [],
      hideButton: false,
      customdata: [],
      selecteddoc: null,
      fielddata: null,
      subcustomdataid: null,
      fields: [],
      flag: 0,
    };

    this.addMore = this.addMore.bind(this);
    this.onEditClicked = this.onEditClicked.bind(this);
    this.getFields = this.getFields.bind(this);
    this.onSave = this.onSave.bind(this);
    this.updatechange = this.updatechange.bind(this);
    this.getIntroComponent = this.getIntroComponent.bind(this);
    this.getViewComponent = this.getViewComponent.bind(this);
    this.getEditComponent = this.getEditComponent.bind(this);
  }

  componentDidMount() {
    const { SubscriptionInfo, AuthenticationAction } = createstore.getState();
    const { SubscriptionData } = SubscriptionInfo;
    const { accountid } = SubscriptionData;
    const { subscriptionid } = SubscriptionData;
    const { countrytimezoneid } = SubscriptionData;
    const DateFormat = get(
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat = typeof DateFormat === "string" ? DateFormat.split(" ") : [""];
    ShortDateFormat = ShortDateFormat[0];
    let employeeid;
    employeeid = SubscriptionData.employeeid;
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9 ? (hideButton = true) : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        ShortDateFormat,
        colleagueid,
        hideButton,
      },
      () => {
        this.getList();
      },
    );
  }

  getList() {
    const data = {
      "employeeid": this.state.colleagueid || this.state.employeeid,
      "isidentity": false,
    };
    instance.post("subscription/getemployeecustomdata", data).then((result) => {
      this.setState({
        docList: result.data.result,
        flag: result.data.result.length == 1 && !result.data.result[0].employeecustomdataid
          && result.data.result[0].addbutton ? 0 : 1,
      });
    })
      .catch((error) => {
        const CommonError = error.response ? error.response.data.error.message : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  addMore() {
    const data = {
      "employeeid": this.state.colleagueid || this.state.employeeid,
      "isidentity": false,
    };
    instance.post("subscription/getemployeecustomdatalist", data).then((result) => {
      this.setState({
        customdata: [...result.data.result.map((obj) => ({ ...obj, displayname: obj.sectionname, displayvalue: obj.subcustomdataid }))],
        flag: 2,
      });
    })
      .catch((error) => {
        const CommonError = error.response ? error.response.data.error.message : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  onEditClicked(doc) {
    this.setState({
      flag: 2,
      selecteddoc: doc,
    });
  }

  getFields(key, value) {
    this.setState({
      [key]: value,
    }, () => {
      instance.get(`subscription/getcustomdatabyid/${value}`).then((result) => {
        this.setState({
          docList: result.data.result,
          fielddata: {
            ...result.data.result[0],
            field: result.data.result[0].field.map((x) => ({
              ...x,
              "fieldvalue": null,
              "fieldoptionid": null,
            })),
          },
        });
      })
        .catch((error) => {
          const CommonError = error.response ? error.response.data.error.message : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    });
  }

  onSave() {
    const { selecteddoc, fielddata, colleagueid, employeeid, subcustomdataid } = this.state;

    const allfields = selecteddoc ? selecteddoc.field && selecteddoc.field.map((x) => ({
      "subcustomdatafieldid": x.subcustomdatafieldid,
      "fieldoptionid": x.inputvaluetypeid == 4 ? x.fieldvalue : x.fieldoptionid,
      "fieldvalue": x.inputvaluetypeid == 4 ? x.fieldoptionid : x.inputvaluetypeid == 3 ? convertDateForBackend(x.fieldvalue) : x.fieldvalue,
      isrequired: x.isrequired,
    })) : fielddata && fielddata.field && fielddata.field.map((x) => ({
      "subcustomdatafieldid": x.subcustomdatafieldid,
      "fieldoptionid": x.inputvaluetypeid == 4 ? x.fieldvalue : x.fieldoptionid,
      "fieldvalue": x.inputvaluetypeid == 4 ? x.fieldoptionid : x.inputvaluetypeid == 3 ? convertDateForBackend(x.fieldvalue) : x.fieldvalue,
      isrequired: x.isrequired,
    }));

    let valid = true;
    valid = allfields && allfields.find((obj) => obj.isrequired && !obj.fieldvalue) ? false : true;

    if (valid) {
      const data = {
        "employeecustomdataid": selecteddoc ? selecteddoc.employeecustomdataid : null,
        "employeeid": colleagueid || employeeid,
        "subcustomdataid": selecteddoc ? selecteddoc.subcustomdataid : subcustomdataid,
        "filetagtypeid": selecteddoc ? selecteddoc.filetagtypeid : fielddata ? fielddata.filetagtypeid : 0,
        "field": allfields,
        "deletedocument": null,
        "updatedocument": null,
        "insertdocument": null,
      };
      console.log('data: ', data);
      instance.post(`subscription/configemployeecustomdata`, data).then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.setState({
          docList: [],
          selecteddoc: null,
          fielddata: null,
          subcustomdataid: null,
          flag: 1,
          customdata: [],
          fields: [],
        }, () => {
          this.getList();
        });
      })
        .catch((error) => {
          const CommonError = error.response ? error.response.data.error.message : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    }
  }

  updatechange(key, value, findex, selectedname) {
    const { selecteddoc, fielddata } = this.state;
    const all = selecteddoc ? selecteddoc.field && selecteddoc.field : fielddata && fielddata.field;
    if (all && all.length > 0) {
      all[findex][key] = value;
      all[findex].fieldoptionid = selectedname ? selectedname : null;
    }
    if (selecteddoc) {
      selecteddoc.field = all;
    } else if (fielddata) {
      fielddata.field = all;
    }
    this.setState({
      selecteddoc,
      fielddata,
    });
  }

  getIntroComponent() {
    const { hideButton } = this.state;
    return (
      <div className="padding-left-24">
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            {!hideButton ? (
              <CreateComp
                text="Add your documents."
                heading="Identity document details"
                onCreate={this.addMore}
                imageSrc={addressEmployee}
              />
            ) : (
                <NoRecordFound />
              )}
          </Grid>
        </Grid>
      </div>
    );
  }

  getViewComponent() {
    const { hideButton, docList } = this.state;
    return (
      <div className="profile-data-view-page padding-left-16 width97 thin-scroll" style={{ overflowY: "auto" }}>
        <Grid container>
          {docList && docList.length > 0
            && docList.map((doc) => (
              <Grid container className="margin-bottom-20">
                <Grid item xs={12} md={11}>
                  <div className="t-16 t-bold text-color-blue">
                    {doc.sectionname}
                  </div>
                  {doc.field && doc.field.map((x) => (
                    <div style={{ marginTop: "3%" }}>
                      <div className="small-dark-secondary t-bold" style={{ marginTop: "5%" }}>
                        {x.fieldname}
                      </div>
                      <div className="t-16">
                        {x.fieldvalue ? x.fieldvalue : " - "}
                      </div>
                    </div>
                  ))}
                </Grid>
                <Grid item xs={12} md={1}>
                  {!hideButton && doc.editbutton
                    && <div className="position-rel">
                      <svg
                        className="address-edit cursour-pointer"
                        width="24"
                        style={{ marginRight: 40 }}
                        height="24"
                        viewBox="0 0 24 24"
                        onClick={() => this.onEditClicked(doc)}>
                        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                      </svg>
                    </div>}
                </Grid>
              </Grid>
            ))}
          {!hideButton && docList && docList[0] && docList[0].addbutton
            && <Button
              style={{ background: '#166ab3', color: 'white', marginTop: "3%", marginBottom: "15%" }}
              onClick={this.addMore}
            >
              <span>
                <FormattedMessage id="LbAddmore" defaultMessage="ADD MORE" />
              </span>
            </Button>}
        </Grid>
      </div>
    );
  }

  getEditComponent() {
    const { docList, subcustomdataid, selecteddoc, fielddata } = this.state;
    return (
      <div className="profile-data-view-page emp-from-wrapper work-experience width60 thin-scroll" style={{ overflowY: "auto" }}>
        {!selecteddoc
          ? <DynamicForm
            className="document"
            fields={selectinputconverter({
              value: subcustomdataid,
              options: this.state.customdata,
              placeholder: "Select custom document",
              label: "Custom document",
            })}
            onChange={(e) => this.getFields("subcustomdataid", e)}

          />
          : <div className="t-16 t-bold text-color-blue">
            {selecteddoc && selecteddoc.sectionname}
          </div>
        }
        {selecteddoc
          ? selecteddoc.field && selecteddoc.field.map((x, fi) => (
            <div>
              {x.inputvaluetypeid == 1
                ? <DynamicForm
                  fields={textinputconverter({
                    value: x.fieldvalue,
                    placeholder: "",
                    label: `${x.fieldname} ${!x.isrequired ? " (Optional)" : ""}`,
                  })}
                  onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                />
                : x.inputvaluetypeid == 2
                  ? <DynamicForm
                    fields={integerinputconverter({
                      value: x.fieldvalue,
                      placeholder: "",
                      label: `${x.fieldname} ${!x.isrequired ? " (Optional)" : ""}`,
                    })}
                    onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                  />
                  : x.inputvaluetypeid == 3
                    ? <DynamicForm
                      fields={dateinputconverter({
                        value: x.fieldvalue,
                        placeholder: "",
                        min: x.isexpiryfield ? new Date() : null,
                        label: `${x.fieldname} ${!x.isrequired ? " (Optional)" : ""}`,
                      })}
                      onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                    />
                    : <DynamicForm
                      fields={selectinputconverter({
                        options: x.option.map((y) => ({
                          ...y,
                          displayvalue: y.subcustomdatafieldoptionid,
                          displayname: y.optionname,
                        })),
                        value: x.option.find((obj) => obj.subcustomdatafieldoptionid == x.fieldoptionid) ? x.fieldoptionid : x.fieldvalue,
                        placeholder: "",
                        label: `${x.fieldname} ${!x.isrequired ? " (Optional)" : ""}`,
                      })}
                      onChange={(e) => this.updatechange("fieldvalue", e, fi,
                        x.option.find((obj) => obj.subcustomdatafieldoptionid == e)
                        && x.option.find((obj) => obj.subcustomdatafieldoptionid == e).optionname)}
                    />}
            </div>
          ))
          : fielddata
          && fielddata.field && fielddata.field.map((x, fi) => (
            <div>
              {x.inputvaluetypeid == 1
                ? <DynamicForm
                  fields={textinputconverter({
                    value: x.fieldvalue,
                    placeholder: "",
                    label: `${x.fieldname} ${!x.isrequired ? " (Optional)" : ""}`,
                  })}
                  onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                />
                : x.inputvaluetypeid == 2
                  ? <DynamicForm
                    fields={integerinputconverter({
                      value: x.fieldvalue,
                      placeholder: "",
                      label: `${x.fieldname} ${!x.isrequired ? " (Optional)" : ""}`,
                    })}
                    onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                  />
                  : x.inputvaluetypeid == 3
                    ? <DynamicForm
                      fields={dateinputconverter({
                        value: x.fieldvalue,
                        min: x.isexpiryfield ? new Date() : null,
                        placeholder: "",
                        label: `${x.fieldname} ${!x.isrequired ? " (Optional)" : ""}`,
                      })}
                      onChange={(e) => this.updatechange("fieldvalue", e, fi)}
                    />
                    : <DynamicForm
                      fields={selectinputconverter({
                        options: x.option.map((y) => ({
                          ...y,
                          displayvalue: y.subcustomdatafieldoptionid,
                          displayname: y.optionname,
                        })),
                        value: x.fieldvalue,
                        placeholder: "",
                        label: `${x.fieldname} ${!x.isrequired ? " (Optional)" : ""}`,
                      })}
                      onChange={(e) => this.updatechange("fieldvalue", e, fi,
                        x.option.find((obj) => obj.subcustomdatafieldoptionid == e)
                        && x.option.find((obj) => obj.subcustomdatafieldoptionid == e).optionname)}
                    />}
            </div>
          ))}
        <Grid container>
          <div style={{ marginTop: 20 }}>
            <Button
              color="primary"
              className="btn btn-primary-md-blue margin-right-8 save"
              variant="contained"
              onClick={this.onSave}
            >
              save
            </Button>
            <Button
              color="primary"
              className="btn btn-secondary-md-blue margin-right-16 Cancel"
              variant="contained"
              onClick={() => this.setState({
                flag: docList.length == 1 && !docList[0].employeecustomdataid
                  && docList[0].addbutton ? 0 : 1,
                customdata: [],
                selecteddoc: null,
                fielddata: null,
                subcustomdataid: null,
                fields: [],
                docList: [],
              }, () => {
                this.getList();
              })}
            >
              Cancel
            </Button>
          </div>
        </Grid>
      </div>
    );
  }

  render() {
    const { datareceived, flag } = this.state;

    return (
      <If condition={datareceived}>
        <If condition={flag == 0}>{this.getIntroComponent()}</If>
        <If condition={flag == 1}>{this.getViewComponent()}</If>
        <If condition={flag == 2}>{this.getEditComponent()}</If>
      </If>
    );
  }
}

export default EmpcustomData;
